export default __webpack_public_path__ + "static/media/config.59eec1b9.svg";